import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "工場コード",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfKojoCd"
    label={label}
    size="small"
    inputProps={{ maxLength: 4 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;